export default __webpack_public_path__ + "static/media/analytics.5909c149.png";